import { useTranslation } from 'react-i18next';
import PulseDot from './PulseDot';

// Soyut "sinyal / veri akışı" görselleştirmesi — analytics/monitoring kimliği.
export default function HeroVisual() {
  const { t } = useTranslation();

  // düzensiz ama gerçekçi görünen bir zaman serisi
  const pts = [8, 14, 10, 18, 13, 22, 16, 28, 20, 34, 24, 30, 44, 62, 40, 33, 38, 30];
  const W = 460;
  const H = 150;
  const stepX = W / (pts.length - 1);
  const max = Math.max(...pts);
  const line = pts.map((p, i) => `${i === 0 ? 'M' : 'L'} ${i * stepX} ${H - (p / max) * (H - 20) - 6}`).join(' ');
  const area = `${line} L ${W} ${H} L 0 ${H} Z`;
  const spikeIdx = pts.indexOf(max);
  const spikeX = spikeIdx * stepX;
  const spikeY = H - (max / max) * (H - 20) - 6;

  const bars = [40, 55, 32, 68, 48, 60, 38, 72, 52, 44, 80, 58];

  return (
    <div className="hero-visual">
      <div className="hv-head">
        <span className="hv-title">{t('hero_visual.title')}</span>
        <span className="badge warn">
          <PulseDot tone="warn" /> {t('hero_visual.anomaly')}
        </span>
      </div>

      <svg viewBox={`0 0 ${W} ${H}`} role="img" aria-label={t('hero_visual.title')}>
        <defs>
          <linearGradient id="hvArea" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="var(--accent)" stopOpacity="0.28" />
            <stop offset="100%" stopColor="var(--accent)" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="hvStroke" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#6aa8ff" />
            <stop offset="60%" stopColor="var(--accent)" />
            <stop offset="100%" stopColor="#ff7d5c" />
          </linearGradient>
        </defs>

        {[0.25, 0.5, 0.75].map((g) => (
          <line key={g} x1="0" y1={H * g} x2={W} y2={H * g} stroke="var(--border)" strokeDasharray="2 4" />
        ))}

        <path d={area} fill="url(#hvArea)" />
        <path
          d={line}
          fill="none"
          stroke="url(#hvStroke)"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ strokeDasharray: 1200, animation: 'trace 2.4s var(--ease-out) forwards' }}
        />

        {/* anomali tepe noktası */}
        <circle cx={spikeX} cy={spikeY} r="9" fill="var(--accent)" opacity="0.16">
          <animate attributeName="r" values="9;16;9" dur="2.2s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.2;0;0.2" dur="2.2s" repeatCount="indefinite" />
        </circle>
        <circle cx={spikeX} cy={spikeY} r="3.5" fill="var(--accent)" />
      </svg>

      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 46, marginTop: 14 }}>
        {bars.map((b, i) => (
          <div
            key={i}
            style={{
              flex: 1,
              height: `${b}%`,
              borderRadius: 3,
              background: i === bars.length - 1 ? 'var(--accent)' : 'var(--surface-3)',
              transition: 'height 0.6s var(--ease)',
            }}
          />
        ))}
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: 16,
          paddingTop: 14,
          borderTop: '1px solid var(--border)',
          fontSize: 12,
          color: 'var(--text-3)',
        }}
      >
        <span className="status-line">
          <PulseDot tone="ok" /> {t('hero_visual.agent_ok')}
        </span>
        <span>{t('hero_visual.window')}</span>
      </div>
    </div>
  );
}
